import { createReducer, on } from '@ngrx/store';
import { setEntidadesSinCredenciales } from '../actions/entidades-sin-credenciales.actions';

export const initialState: string = '';

export const entidadesSinCredencialesReducer = createReducer(
  initialState,
  on(setEntidadesSinCredenciales, (_state, { item }) => item)
);
